import http from "../../utils/httpClient"

class administratorService {

  getAllCachingData = async (query) => {
    return await http.get("/api/Administrator/GetAllRedisKey", { params: query })
  }

  deleteCachingData = async (query) => {
    return await http.get("/api/Administrator/RemoveRedisKeyCache", { params: query })
  }

}
export default new administratorService()
